<template>
	<div id="resumoAlertasJusBr">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="5">
				<a-row>
					<span>Tribunal:</span>
				</a-row>
				<a-row>
					<a-input
						style="width: 95%;"
						placeholder="Tribunal"
						v-model="valueTribunal"			
						@change="onChangeTribunal"						
						:disabled="loading"			
						>					
					</a-input>
				</a-row>
			</a-col>
			<a-col :span="5">
				<a-row>
					<span>Fornecedor:</span>
				</a-row>
				<a-row>
					<a-input
						style="width: 95%;"
						placeholder="Fornecedor"
						v-model="valueFornecedor"		
						@change="onChangeFornecedor"						
						:disabled="loading"	
						>					
					</a-input>
				</a-row>
			</a-col>
			<!-- <a-col :span="3">
				<a-row>
					<span>Tipo Credencial:</span>
				</a-row>
				<a-select
					style="width: 95%;"
					@change="onChangeTipoCredencial"
					:value="valueTipoCredencial"
					:disabled="loading"
					:allowClear="valueTipoCredencial!='4'"
					>
					<a-select-option value="4">Todos</a-select-option>
					<a-select-option value="1">Dado</a-select-option>
					<a-select-option value="2">Autos</a-select-option>
					<a-select-option value="3">Autos/Dado</a-select-option>
				</a-select>
			</a-col> -->

			<a-col :span="3">
				<a-row>
					<span class="tr-label">Inicial:</span>
				</a-row>
				<a-row>
					<a-date-picker
						@change="onChangeDataIncialErro"
						placeholder="Data Incial"
						style="width: 95%;"
						:format="dateFormat"
						:disabled="loading"
					/>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span class="tr-label">Final:</span>
				</a-row>
				<a-row>
					<a-date-picker
						@change="onChangeDataFinalErro"
						placeholder="Data Final"
						style="width: 95%;"
						:format="dateFormat"
						:disabled="loading"
					/>
				</a-row>
			</a-col>
			
			<a-col :span="3" style="text-align: right;">
				<a-button
					class="tr-search-btn"
					type="primary"
					@click.stop.prevent="carregarResumoAlertasJusBr()"
					:disabled="loading"
				>Pesquisar</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="columns"
				:rowKey="record => record.idCliente"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				
				<template
						slot="tipoCredencial"
						slot-scope="tipoCredencial, record"
					>{{formatarTipoCredencial(record.tipoCredencial)}}
				</template>
				<template
					slot="dataCadastro"
					slot-scope="dataCadastro, record"
				>{{formatarDataLocal(record.dataCadastro, true, 'DD/MM/YYYY HH:mm:ss')}}
				</template>
			</a-table>
			<a-row type="flex" align="bottom">
					<a-button
						class="btnExcel"
						type="primary"
						icon="file-excel"
						size="default"
						@click.stop.prevent="exportarExcel"
					></a-button>
			</a-row>
		</a-row>
	</div>
</template>

<script>
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import ModalComponent from "@/components/ModalComponent";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";


const columns = [
	{
		title: "Tribunal",
		dataIndex: "tribunal",
		width: "20%",
		sorter: (a, b) => a.tribunal.localeCompare(b.tribunal),		
		scopedSlots: { customRender: "tribunal" }
	},
	{
		title: "Fornecedor",
		dataIndex: "fornecedor",
		width: "10%",
		sorter: (a, b) => a.fornecedor.localeCompare(b.fornecedor),
		scopedSlots: { customRender: "fornecedor" }
	},
	{
		title: "NPU",
		dataIndex: "processo",
		width: "20%", 
		sorter: (a, b) => a.processo.localeCompare(b.processo),
		scopedSlots: { customRender: "processo" }
	},
	{
		title: "Tipo Credencial",
		dataIndex: "tipoCredencial",
		width: "10%", 
		sorter: (a, b) => a.tipoCredencial.localeCompare(b.tipoCredencial),
		scopedSlots: { customRender: "tipoCredencial" }
	},
	{
		title: "Data",
		dataIndex: "dataCadastro",
		sorter: (a, b) => a.dataCadastro.localeCompare(b.dataCadastro),
		width: "15%",
		scopedSlots: { customRender: "dataCadastro" }
	},
	
	{
		title: "Erro",
		dataIndex: "mensagemErro",
		sorter: (a, b) => a.mensagemErro - b.mensagemErro,	
		width: "20%",	
		align: "center",
		scopedSlots: { customRender: "mensagemErro" }
	}
];

export default {	
	name: "resumoAlertasJusBr",
	data() {
		return {
			idTela: 9,
			data: [],
			pagination: {},
			loading: false,
			dateFormat: "DD/MM/YYYY",
			columns,
			filter:{
				tribunal: '',
				fornecedor: '',
				dataInicialErro: '',
				dataFinalErro: '',
				tipoCredencial: "4",
				idUsuario: null,
				idPerfil: null
			},
			valueFornecedor: '',
			valueTribunal: '',
			valueTipoCredencial: '4',
			valueDataInicialErro: null,
			valueDataFinalErro: null,
			selectedRowKeys: [],
		};
	},
	mounted() {    
		// this.carregarResumoAlertasJusBr();       
	},
	methods: {
		carregarResumoAlertasJusBr() {
			if (!this.validarFiltro()){
				return;
			}
			
			this.filter.idUsuario = this.$store.state.auth.idUser
			this.filter.idPerfil = this.$store.state.auth.idPerfilPortal
			this.loading = true;
			PortalCredencialWebApi.getResumoAlertasJusBr(this.filter).then(res => {
				this.loading = false;
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Relatório de Alertas JusBR", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Relatório de Alertas JusBR", res.data.result);
				} else {
					this.data = res.data.result;
					this.pagination = { current: 1 };
				}
			})
			.catch(res => {
				this.loading = false;
				showNotificationError(this, "Relatório de Alertas JusBR", "Erro ao tentar carregar lista de fonte monitoradas.");
			});
			
		},
		async exportarExcel() {
			PortalCredencialWebApi.exportarRelatorioAlertasJusBr(this.filter)
				.then(res => {
					this.loading = false;
					let arrayValidacao = [null, "undefined", ""]
					let data = res.data;					
					if (!arrayValidacao.includes(data)) {
						let blob = new Blob([res.data], {
							type: "application/vnd.ms-excel"
						});
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);						
						link.download = "Relatório_Resumo_Alertas_JusBR" + new Date().toLocaleDateString() + ".xlsx";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					} else {
						showNotificationError(this, "Relatório de Alertas JusBR", "Erro ao tentar gerar arquivo.");
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Relatório de Alertas JusBR", "Erro ao tentar gerar arquivo.");
				});
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
      		pager.current = pagination.current;
      		this.pagination = pager;
		},
		onChangeFornecedor() {	
			this.filter.fornecedor = this.valueFornecedor == '' ? null : this.valueFornecedor;
		},
		onChangeTribunal() {
			this.filter.tribunal = this.valueTribunal == '' ? null : this.valueTribunal;
		},
		onChangeTipoCredencial(value) {
			this.valueTipoCredencial = value == undefined ? '4' : value;
			this.filter.tipoCredencial = this.valueTipoCredencial == '4' ? null : this.valueTipoCredencial;
		},
		onChangeDataIncialErro(date, dateString) {
			this.valueDataInicialErro = dateString == '' ? null : date;
			this.filter.dataInicialErro = this.valueDataInicialErro == '' ? null : this.valueDataInicialErro;
		},
		onChangeDataFinalErro(date, dateString) {
			this.valueDataFinalErro = dateString == '' ? null : date;
			this.filter.dataFinalErro = this.valueDataFinalErro == '' ? null : this.valueDataFinalErro;

		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
		formatarTipoCredencial(value){
			return Helpers.formatarTipo(value);
		},
		validarFiltro() {
			let diff = moment(this.filter.dataFinalErro, "DD/MM/YYYY").diff(moment(this.filter.dataInicialErro, "DD/MM/YYYY"));

			if (moment.duration(diff)._data.days < 0)
			{
				showNotificationError(this, "Relatório de Alertas JusBR", "Data Final não pode ser menor do que a Data Inicial.");
				return false;
			}
			if (moment.duration(diff)._data.months >= 1 || moment.duration(diff)._data.years >= 1)
			{
				showNotificationError(this, "Relatório de Alertas JusBR", "Período não pode ser maior do que 30 dias.");
				return false;
			}
			if (this.valueDataInicialErro == null || this.valueDataFinalErro == null){
				showNotificationError(this, "Relatório de Alertas JusBR", "Data Inicial e Final é um campo Obrigatório!");
				return false;
			}

			return true;
		}
	},    
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

div .ant-row-flex {
	margin-top: 5px;
	margin-bottom: 10px;
}

.content {
  height: 100%;
}

.ant-layout {
  height: 100%;
  background: "#fff";
}

.ant-layout-content {
  height: 100%;
  background: #fff;
}

.ant-layout-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
 
.cursor {
  cursor: pointer;
}

.cursor:hover {
  color: blue;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}

.config-form-button {
	width: 100px;
}

.tr-ant-select {
	margin: 10px 0px 10px 0px;
} 
.btnExcel {
	text-align: 'center';
	position: 'relative'; 
	width: 45px;
	height: 45px;
	font-size: 24px;
	font-weight: bold;
	cursor: pointer;
	border-radius: 50%;
}
.btnExcel:hover {
	background-color: #0755A4;
	transition: all 0.3s ease-in;
}
</style>

<style>
</style>